import _ from 'underscore';
import $ from 'jquery';

export default class NewsletterRecipients {
  constructor($scope, $rootScope, NewsletterService) {

    $scope.filter = {
      user_type_buyers: true,
      user_type_sellers: true,
      user_countries: []
    };

    $scope.tabs = [
      {
        title: 'General',
        buyers: []
      }
    ];

    $scope.toggleEUcountries = function toggleEUcountries(check_eu_countries) {
      if (check_eu_countries){
        if (!$scope.filter.user_countries) {
          $scope.filter.user_countries = [];
        }
        $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.eu_countries);
      } else {
        $scope.filter.user_countries = _.difference($scope.filter.user_countries,$scope.eu_countries);
      }
      $('#countries').select2('val', $scope.filter.user_countries);
    };
    
    $scope.toggleAsiacountries = function toggleAsiacountries(check_asia_countries) {
      if (check_asia_countries){
        if (!$scope.filter.user_countries) {
          $scope.filter.user_countries = [];
        }
        $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.asia_countries);
      } else {
        $scope.filter.user_countries = _.difference($scope.filter.user_countries,$scope.asia_countries);
      }
      $('#countries').select2('val', $scope.filter.user_countries);
    };
    
    $scope.toggleAfricacountries = function toggleAfricacountries(check_africa_countries) {
      if (check_africa_countries){
        if (!$scope.filter.user_countries) {
          $scope.filter.user_countries = [];
        }
        $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.africa_countries);
      } else {
        $scope.filter.user_countries = _.difference($scope.filter.user_countries,$scope.africa_countries);
      }
      $('#countries').select2('val', $scope.filter.user_countries);
    };
    
    $scope.toggleNAmericacountries = function toggleNAmericacountries(check_n_america_countries) {
      if (check_n_america_countries){
        if (!$scope.filter.user_countries) {
          $scope.filter.user_countries = [];
        }
        $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.n_america_countries);
      } else {
        $scope.filter.user_countries = _.difference($scope.filter.user_countries,$scope.n_america_countries);
      }
      $('#countries').select2('val', $scope.filter.user_countries);
    };

    $scope.toggleSAmericacountries = function toggleSAmericacountries(check_s_america_countries) {
      if (check_s_america_countries){
        if (!$scope.filter.user_countries) {
          $scope.filter.user_countries = [];
        }
        $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.s_america_countries);
      } else {
        $scope.filter.user_countries = _.difference($scope.filter.user_countries,$scope.s_america_countries);
      }
      $('#countries').select2('val', $scope.filter.user_countries);
    };

    $scope.check_items = function(tab_index) {
      _.each($scope.get_users($scope.tabs[tab_index]), function(user) {
        user.checked = $scope.tabs[tab_index].checked;
      });
    };

    $scope.select2_options = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '600px'
    };
    
    $scope.select2_options_447 = {
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '600px'
    };

    $scope.search = function() {
      $scope.searching = true;
      NewsletterService.find_recipients($scope.newsletter.id, $scope.filter).success(function(data) {
        $scope.tabs[0].users = data.recipients.users;
        $scope.searching = false;
      });
    };

    $scope.add_recipients = function() {
      var users = _.where($scope.tabs[0].users, {
        checked: true
      });
      if (!$scope.adding && (users.length > 0)) {
        $scope.adding = true;
        $scope.recipients_added = false;
        NewsletterService.add_recipients(window.newsletter.id, users).success(function(data) {
          if (data.success) {
            $scope.tabs[0].users = _.difference($scope.tabs[0].users, users);
            $scope.tabs[0].checked = false;
            $scope.adding = false;
            $scope.recipients_added = true;
          }
        });
      }
    };

    $scope.automate_recipients = function() {
      var buyers = _.where($scope.tabs[0].users, {
        checked: true
      });
      if (buyers.length > 0) {
        var data = {
          newsletter_id: window.newsletter.id,
          buyers: buyers,
          min_quantity: $scope.min_quantity
        };
        $rootScope.$broadcast('show_recipients_dialog', data);
      }
    };

    $scope.$on('remove_automated_recipients', function(event, data) {
      $scope.tabs[0].users = _.difference($scope.tabs[0].users, data.buyers);
      $scope.tabs[0].checked = false;
    });


    $scope.get_users = function(tab) {
      var users = tab.users;

      return users;
    };

    $scope.uncheck_items = function() {
      _.each($scope.tabs, function(tab) {
        tab.checked = false;
        _.each(tab.users, function(buyer) {
          buyer.checked = false;
        });
      });
    };

    $scope.get_newsletter_criteria = function(newsletter_criteria) {
      var status = _.findWhere(window.newsletter_criteria_statuses, {
        id: newsletter_criteria
      });
      return status.title;
    };

    $scope.quick_search = function(tab_index) {
      window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
    };


    $scope.remove_user = function(user_id) {
      $scope.filter.users = _.reject($scope.filter.users, function(user) {
        return user.id == user_id;
      });
    };

    $scope.quick_search_end_uses = function() {
      if ($scope.quick_filter) {
        var regex = new RegExp($scope.quick_filter, 'i');
        _.each($scope.product_end_uses, function(end_use) {
          end_use.visible = end_use.title.search(regex) > -1;
        });

        $scope.search_filter = {
          visible: true
        };
      } else {
        $scope.search_filter = {};
      }
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.newsletter = window.newsletter;
      $scope.current_page = 'recipients_find';
      $scope.eu_countries = window.eu.countries.map(a => String(a.id));
      $scope.asia_countries = window.asia.countries.map(a => String(a.id));
      $scope.africa_countries = window.africa.countries.map(a => String(a.id));
      $scope.n_america_countries = window.n_america.countries.map(a => String(a.id));
      $scope.s_america_countries = window.s_america.countries.map(a => String(a.id));
      if (_.difference($scope.eu_countries, $scope.filter.user_countries).length === 0) {
        $scope.check_eu_countries = true;
      }
      if (_.difference($scope.asia_countries, $scope.filter.user_countries).length === 0) {
        $scope.check_asia_countries = true;
      }
      if (_.difference($scope.africa_countries, $scope.filter.user_countries).length === 0) {
        $scope.check_africa_countries = true;
      }
      if (_.difference($scope.n_america_countries, $scope.filter.user_countries).length === 0) {
        $scope.check_n_america_countries = true;
      }
      if (_.difference($scope.s_america_countries, $scope.filter.user_countries).length === 0) {
        $scope.check_s_america_countries = true;
      }

      $('#countries').select2('val', $scope.eu_countries);
    };

    $scope.init();
  }
}

NewsletterRecipients.$inject = ['$scope', '$rootScope', 'NewsletterService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/newsletter-recipients.ctrl.js